import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {switchMap, take} from 'rxjs/operators';
import {BasicPersonDetailDTO} from '../../../../ent/models/person/BasicPersonDetailDTO';
import {detailsExpand} from '../../../animations';
import {SharedService} from '../../../services/shared-service';
import {UserAuthorisationService} from '../../../services/user-authorisation.service';
import { HttpHeaders } from '@angular/common/http';
import {InsuredPersonDTO} from '../../../../ent/models/InsuredPersonDTO';
import {InsuredPersonService} from '../../../../ent/services/insured-person.service';
import {AlulaHealthCloudService, HealthDetail} from '../../../../ent/services/alula-health-cloud.service';
import {ArrowDirection} from '../../../modules/health-score-guage/ArrowDirection';

@Component({
  selector: 'app-vivascore-profile-overview',
  templateUrl: './vivascore-profile-overview.component.html',
  styleUrls: [
    '../../../../../../styles/global/_management-styles.scss',
    '../../../../../../styles/global/_dialog-styles.scss',
  ],
  animations: [detailsExpand]
})
export class VivascoreProfileOverviewComponent {
  readonly ArrowDirection = ArrowDirection;
  readonly hearts = [
    {color: 'Red', text: 'Poor'},
    {color: 'Pink', text: 'Fair'},
    {color: 'Yellow', text: 'Average'},
    {color: 'LightGreen', text: 'Good'},
    {color: 'Green', text: 'Excellent'}
  ];
  disableUpdateButton: boolean;
  healthData: HealthDetail;
  insuredPersonDTO: InsuredPersonDTO; // Get NationalID as VivaScore fetched details on nationalID number

  constructor(
    private alulaHealthCloudService: AlulaHealthCloudService,
    private sharedService: SharedService,
    private userAuthorisationService: UserAuthorisationService,
    private insuredPersonService: InsuredPersonService,
    @Inject(MAT_DIALOG_DATA) public basicPersonDetails: BasicPersonDetailDTO) {
    this.disableUpdateButton = this.disableUpdateButtonBasedOnRoles();
  }

  getHealthScoreDetails(insuredPersonId: number): void {
    if (!insuredPersonId) {
      return;
    }
    this.insuredPersonService.getInsuredPerson(insuredPersonId)
      .pipe(
        switchMap((response: InsuredPersonDTO) => {
          this.insuredPersonDTO = response;
          return this.alulaHealthCloudService.getAccessTokenFromHealthCloudAPI()
            .pipe(
              switchMap((tokenResponse: {
                accessToken: string,
                tokenType: string,
                expiresIn: number
              }) => {
                const headers: HttpHeaders = new HttpHeaders({
                  Authorization: `${tokenResponse?.tokenType} ${tokenResponse?.accessToken}`
                });
                return this.alulaHealthCloudService.getScoreDetailsFromHealthCloudAPI(this.insuredPersonDTO?.nationalIdNumber, headers);
              }),
              take(1)
            );
        }),
      )
      .subscribe({
        next: (response: HealthDetail) => {
          this.healthData = response;
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error?.message || 'Failed to get health score details from Health Cloud API');
        }
      });
  }

  disableUpdateButtonBasedOnRoles(): boolean {
    let disabled = true;
    if (this.userAuthorisationService.hasRoleTransactionTeamLeader()) {
      disabled = false;
    }
    return disabled;
  }

}
